import "../../../../assets/presentation/components/controls/drop-down/select-drop-down-C_b2ULgD.css";
import { Symbol } from "../symbol/symbol2.js";
import { Conditional } from "../../components.js";
import { isEmpty } from "../../../../utils/matchers/matchers.js";
import { useTransient } from "../../../hooks/use-transient.js";
import { registerModalView } from "../../modal-views/register-modal-view.js";
import { DropDown, DropDownContent } from "../../modal-views/drop-down2.js";
/* empty css                 */
import classNames from "classnames";
import { useEffect, useRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/presentation/components/controls/drop-down/select-drop-down.tsx
var SELECT_DROP_DOWN_KEY = "SelectDropDownKey";
var SelectDropDown = ({ className, hide, anchor, options, dropDownKey, useFullConstraintWidth = false }) => {
	const [, setTransient] = useTransient({ key: SELECT_DROP_DOWN_KEY + dropDownKey });
	const [, setDropDownInputCloseOutsideTransient] = useTransient({ key: "drop-down-input-close-outside-transient" });
	const ref = useRef(null);
	useEffect(() => {
		const handler = () => {
			setDropDownInputCloseOutsideTransient({ closeDropDown: "closeDropDown" });
		};
		document.addEventListener("mousedown", handler);
		return () => {
			setDropDownInputCloseOutsideTransient({ closeDropDown: "" });
			document.removeEventListener("mousedown", handler);
		};
	}, [hide]);
	return /* @__PURE__ */ jsx(DropDown, {
		anchor,
		hide,
		ref,
		useFullConstraintWidth,
		className: classNames(className, "select-drop-down"),
		children: /* @__PURE__ */ jsx(DropDownContent, { children: /* @__PURE__ */ jsx("ul", {
			className: "dropdown-options",
			children: options?.map((option, index) => /* @__PURE__ */ jsxs("li", {
				className: "flex gap-4",
				onClick: () => {
					setTransient({
						selectedValue: option.value,
						selectedLabel: option.label,
						selectedIcon: option.icon
					});
					hide();
				},
				children: [/* @__PURE__ */ jsx(Conditional, {
					condition: !isEmpty(option.icon),
					children: /* @__PURE__ */ jsx(Symbol, {
						className: "select-drop-down-symbol",
						symbol: String(option.icon)
					})
				}), /* @__PURE__ */ jsx("p", { children: option.label })]
			}, index))
		}) })
	});
};
registerModalView(SELECT_DROP_DOWN_KEY, (props) => /* @__PURE__ */ jsx(SelectDropDown, {
	anchor: props.anchor,
	className: props.className,
	hide: props.hide,
	options: props.options,
	dropDownKey: props.dropDownKey,
	useFullConstraintWidth: props.useFullConstraintWidth
}));
//#endregion
export { SELECT_DROP_DOWN_KEY, SelectDropDown };

//# sourceMappingURL=select-drop-down2.js.map